import React from 'react';

import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';

import MyWorkSectionLegacy from './MyWorkSectionLegacy';
import MyWorkSectionV2 from './MyWorkSectionV2';

/** Flag wrapper for the legacy and redesigned My Work sections. */
export default function MyWorkSection(): JSX.Element | null {
  const {navEnableHomepageMyWorkRedesign} = useRolloutFlags();
  if (navEnableHomepageMyWorkRedesign === true) {
    return <MyWorkSectionV2 />;
  }

  return <MyWorkSectionLegacy />;
}
